import React from 'react';
import { FileCode, Layout, Activity, Shield, TestTube } from 'lucide-react';

const TechnicalDetailsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  complexityLevels 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <FileCode className="w-5 h-5 mr-2 text-indigo-500" />
        Технические параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Количество смарт-контрактов */}
        <div>
          <label htmlFor="smartContracts" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Количество смарт-контрактов
          </label>
          <input
            type="text"
            id="smartContracts"
            name="smartContracts"
            value={formData.smartContracts}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.smartContracts ? 'input-error' : ''}`}
            placeholder="Например: 3"
          />
          {errors.smartContracts && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.smartContracts}
            </p>
          )}
        </div>

        {/* Сложность смарт-контрактов */}
        <div>
          <label htmlFor="smartContractsComplexity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Сложность смарт-контрактов
          </label>
          <select
            id="smartContractsComplexity"
            name="smartContractsComplexity"
            value={formData.smartContractsComplexity}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.smartContractsComplexity ? 'input-error' : ''}`}
          >
            {complexityLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.smartContractsComplexity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.smartContractsComplexity}
            </p>
          )}
        </div>

        {/* Сложность UI */}
        <div>
          <label htmlFor="frontendComplexity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Layout className="w-4 h-4 mr-2 text-indigo-500" />
            Сложность пользовательского интерфейса
          </label>
          <select
            id="frontendComplexity"
            name="frontendComplexity"
            value={formData.frontendComplexity}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.frontendComplexity ? 'input-error' : ''}`}
          >
            {complexityLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.frontendComplexity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.frontendComplexity}
            </p>
          )}
        </div>

        {/* Особые требования к UI */}
        <div>
          <label htmlFor="customUIRequirements" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Требования к UI
          </label>
          <select
            id="customUIRequirements"
            name="customUIRequirements"
            value={formData.customUIRequirements}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="minimal">Минимальный дизайн</option>
            <option value="standard">Стандартный дизайн</option>
            <option value="premium">Премиум дизайн</option>
            <option value="custom">Кастомный брендинг</option>
          </select>
        </div>

        {/* Уровень тестирования */}
        <div>
          <label htmlFor="testingLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <TestTube className="w-4 h-4 mr-2 text-indigo-500" />
            Уровень тестирования
          </label>
          <select
            id="testingLevel"
            name="testingLevel"
            value={formData.testingLevel}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="basic">Базовое тестирование</option>
            <option value="standard">Стандартное тестирование</option>
            <option value="comprehensive">Комплексное тестирование</option>
            <option value="extensive">Расширенное тестирование</option>
          </select>
        </div>

        {/* Выбор технических опций */}
        <div className="col-span-full">
          <div className="mt-3 space-y-2">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="backendIntegration"
                checked={formData.backendIntegration}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
                <Activity className="w-4 h-4 mr-1 text-indigo-500" />
                Интеграция с бэкендом/API
              </span>
            </label>

            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="securityAudit"
                checked={formData.securityAudit}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
                <Shield className="w-4 h-4 mr-1 text-indigo-500" />
                Аудит безопасности смарт-контрактов
              </span>
            </label>

            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="deploymentSupport"
                checked={formData.deploymentSupport}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Поддержка при развертывании и настройке
              </span>
            </label>
          </div>
        </div>
      </div>

      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
        <div className="flex items-start">
          <FileCode className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              О выборе технологий
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Сложность смарт-контрактов и выбор блокчейн-платформы значительно влияют на стоимость проекта. Аудит безопасности рекомендуется для всех продакшн-решений, связанных с финансами.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnicalDetailsSection;